import _ from 'lodash'
import api, { formCfg, listDehydrate } from './api'
import apiFactory from './api-factory'

const gisTag = {
  ...apiFactory('/api/gis_regions/gis_tag/', ['getList', 'create', 'delete'], {
    hydrate,
    dehydrate,
  }),

  getUnapprovedList(params, context) {
    return api
      .get('/api/gis_regions/gis_tag/unapproved/', formCfg(params, context))
      .then((response) => listDehydrate(response.data, unapprovedDehydrate))
  },

  approve(pk, params, context) {
    return api.put(
      `/api/gis_regions/gis_tag/${pk}/approve/`,
      formCfg(params, context)
    )
  },

  refuse(pk, params, context) {
    return api.put(
      `/api/gis_regions/gis_tag/${pk}/refuse/`,
      formCfg(params, context)
    )
  },
}

function unapprovedDehydrate({ pk, name, approved, level, parents }) {
  return {
    pk,
    name,
    approved,
    level,
    parents: _.map(parents, dehydrate),
  }
}

export function dehydrate({
  pk,
  name,
  childrenCount,
  approved,
  parentTag,
  level,
}) {
  return {
    pk,
    name,
    childrenCount,
    approved,
    parentTag,
    level,
  }
}

export function hydrate({ name, parentTag }) {
  return {
    name,
    parentTag,
  }
}

export default gisTag
